import { BlockConfig, OperationTypes, ContentTypes } from "../block-base";
import { BlockTypes } from "../block-types";

export const documentDbConfig: BlockConfig = {
  displayName: "Document DB",
  imagePath: "",
  isInitiator: true,
  isTerminator: false,
  isInterceptor: false,
  allowedInputTypes: new Set([
    BlockTypes.APP_SERVER,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.CACHE,
    BlockTypes.LAMBDA,
    BlockTypes.NETWORK_LOAD_BALANCER,
    BlockTypes.PASSTHROUGH,
  ]),
  allowedOutputTypes: new Set(),
  inputCapacity: {
    total: 5100,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 2850,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 400,
          [`${ContentTypes.STATIC}`]: 1500,
          [`${ContentTypes.STATIC_MEDIA}`]: 950,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 2250,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 1500,
          [`${ContentTypes.STATIC_MEDIA}`]: 750,
        },
      },
    },
  },
  processingCapacity: {
    total: 5100,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 2850,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 400,
          [`${ContentTypes.STATIC}`]: 1500,
          [`${ContentTypes.STATIC_MEDIA}`]: 950,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 2250,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 1500,
          [`${ContentTypes.STATIC_MEDIA}`]: 750,
        },
      },
    },
  },
  purchasePrice: 175,
  sellPrice: 85,
  costPerCycle: 1.3,
  outputConnectorLimits: {},
};
